import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import mainImage from '../../assets/img/computer.png'; // Replace with actual image path
import thumbnail1 from '../../assets/blog/b1 Square copy.png';
import thumbnail2 from '../../assets/blog/B2 Square copy.png';
import thumbnail3 from '../../assets/blog/B3 Square copy.png';
import thumbnail4 from '../../assets/blog/b4 copy.png';
import { api } from '../../api';

const PlaylistPage = () => {
    const playlistItems = [
        { id: 1, image: thumbnail1, title: "Learn from My Mistakes: 7 Digital Course Pitfalls to Skip", description: "Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield." },
        { id: 2, image: thumbnail2, title: "Learn from My Mistakes: 7 Digital Course Pitfalls to Skip", description: "Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield." },
        { id: 3, image: thumbnail3, title: "Learn from My Mistakes: 7 Digital Course Pitfalls to Skip", description: "Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield." },
        { id: 4, image: thumbnail4, title: "Learn from My Mistakes: 7 Digital Course Pitfalls to Skip", description: "Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield." },
        { id: 5, image: thumbnail4, title: "Learn from My Mistakes: 7 Digital Course Pitfalls to Skip", description: "Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield." },
    ];

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: ''
    });
    const [errors, setErrors] = useState({});

    const validateEthiopianPhoneNumber = (phone) => {
        // Ethiopian phone number regex patterns
        const patterns = [
            /^(\+251|0)(9|7)[0-9]{8}$/,       // Mobile (+251 or 0 followed by 9 or 7)
            /^(\+251|0)(11|12|13|14|15|16|17|18|19|22|23|24|25|33|34|35|36|41|44|46|47|51|54|55|56|57|58|59|61|62|65|67|68|71|72|73|74|75|76|77|79|81|82|83|84|85|86|87|88|89|91|92|93|94|95|96|97|98|99)[0-9]{6}$/ // Landlines
        ];
        
        // Remove all whitespace and special characters except + and numbers
        const cleanedPhone = phone.replace(/[^\d+]/g, '');
        
        // Check if the cleaned phone matches any pattern
        return patterns.some(pattern => pattern.test(cleanedPhone));
    };

    const formatPhoneNumber = (phone) => {
        // Format to standard +251 format
        let cleaned = phone.replace(/[^\d+]/g, '');
        
        // Convert 0 to +251
        if (cleaned.startsWith('0')) {
            cleaned = '+251' + cleaned.substring(1);
        }
        // Ensure +251 is used
        else if (cleaned.startsWith('251')) {
            cleaned = '+' + cleaned;
        }
        
        return cleaned;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        // Clear error when user types
        if (errors[name]) {
            setErrors({
                ...errors,
                [name]: ''
            });
        }
    };

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.firstName.trim()) newErrors.firstName = 'First name is required';
        if (!formData.lastName.trim()) newErrors.lastName = 'Last name is required';
        
        // Email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!emailPattern.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }

        // Phone validation
        if (!formData.phoneNumber.trim()) {
            newErrors.phoneNumber = 'Phone number is required';
        } else if (!validateEthiopianPhoneNumber(formData.phoneNumber)) {
            newErrors.phoneNumber = 'Please enter a valid Ethiopian phone number';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            const subscriberData = {
                first_name: formData.firstName,
                last_name: formData.lastName,
                email: formData.email,
                phone_number: formatPhoneNumber(formData.phoneNumber),
            };

            const response = await api.post("/subscribers", subscriberData);
            
            Swal.fire({
                title: 'Thank You!',
                text: 'You have successfully signed up for our newsletter.',
                icon: 'success',
                confirmButtonText: 'Great!',
                confirmButtonColor: '#FD5F20',
            });

            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: ''
            });
        } catch (error) {
            Swal.fire({
                title: 'Error!',
                text: error.response?.data?.message || 'Failed to sign up. Please try again later.',
                icon: 'error',
                confirmButtonText: 'Okay',
                confirmButtonColor: '#FD5F20',
            });
        }
    };

    return (
        <div className="flex flex-col min-h-screen overflow-hidden ">
            {/* Main Image and Playlist Section */}
            <div className="flex flex-col md:flex-row flex-grow gap-4 w-full px-4 md:px-0">
                <div className="relative flex-1 md:w-3/5 min-h-full">
                    <img
                        src={mainImage}
                        alt="Main content"
                        className="w-full h-full object-cover rounded-lg"
                    />
                    <div className="absolute bottom-0 left-0 w-full backdrop-blur-sm p-4 rounded-lg">
                        <p className="text-gray-100 text-sm mb-2">
                            <strong>Zafor Iqubal</strong> - 17 Oct, 2024
                        </p>
                        <h1 className="text-lg md:text-2xl font-bold text-white">
                            What is Digital Marketing?
                        </h1>
                        <p className="mt-2 text-xs md:text-base text-white">
                            Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield.
                        </p>
                        <div className="mt-4 flex flex-wrap gap-2">
                            <button className="bg-[#FD5F20] text-white px-4 py-1 rounded hover:bg-orange-600 transition">
                                PPC
                            </button>
                            <button className="bg-[#FD5F20] text-white px-4 py-1 rounded hover:bg-blue-600 transition">
                                CRO
                            </button>
                            <button className="bg-[#FD5F20] text-white px-4 py-1 rounded hover:bg-green-600 transition">
                                Affiliate Marketing
                            </button>
                        </div>
                    </div>
                </div>
                <div className="md:w-2/5 px-2 min-h-full overflow-y-auto">
                    <h2 className="text-lg font-semibold mb-2">Latest Blogs</h2>
                    <div className="space-y-4">
                        {playlistItems.map((item) => (
                            <Link
                                key={item.id}
                                to="/Blog/LatestBlogs"
                                className="flex items-start gap-4 hover:bg-gray-100 rounded-lg p-2 transition-colors duration-200"
                            >
                                <img
                                    src={item.image}
                                    alt={item.title}
                                    className="w-1/5 min-w-[100px] h-auto object-cover rounded-lg"
                                />
                                <div className="flex-1 min-w-0">
                                    <p className="text-gray-600 text-md break-words">
                                        {item.description}
                                    </p>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        
            {/* Sign Up Form Section */}
            <div className="flex flex-col md:flex-row w-full py-4 px-4 md:px-0">
                <div className=" p-6 rounded-lg  w-full md:max-w-md md:w-1/3">
                    <h2 className="text-2xl font-bold mb-2">Sign Up for News + Offers</h2>
                    <p className="text-gray-600 mb-4">
                        Receive exciting round-ups, including exclusive offers, insights into new creative projects, articles, design industry updates, and much more.
                    </p>
                </div>
                <form onSubmit={handleSubmit} className="w-full p-4 mt-4 md:mt-0 md:ml-4 md:w-2/3">
                    <div className="flex flex-col md:flex-row  md:gap-8">
                        <div className="mb-4 w-full">
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 border-2 ${errors.firstName ? 'border-red-500' : 'border-[#FD5F20]'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FD5F20] placeholder-gray-500`}
                                placeholder="Enter your first name"
                                aria-label="First Name"
                            />
                            {errors.firstName && <p className="text-red-500 text-sm mt-1">{errors.firstName}</p>}
                        </div>
                        <div className="mb-4 w-full">
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 border-2 ${errors.lastName ? 'border-red-500' : 'border-[#FD5F20]'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FD5F20] placeholder-gray-500`}
                                placeholder="Enter your last name"
                                aria-label="Last Name"
                            />
                            {errors.lastName && <p className="text-red-500 text-sm mt-1">{errors.lastName}</p>}
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row md:gap-8">
                        <div className="mb-4 w-full">
                            <input
                                type="email"
                                id="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 border-2 ${errors.email ? 'border-red-500' : 'border-[#FD5F20]'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FD5F20] placeholder-gray-500`}
                                placeholder="Enter your email"
                                aria-label="Email"
                            />
                            {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                        </div>
                        <div className="mb-4 w-full">
                            <input
                                type="tel"
                                id="phoneNumber"
                                name="phoneNumber"
                                value={formData.phoneNumber}
                                onChange={handleChange}
                                className={`w-full px-3 py-2 border-2 ${errors.phoneNumber ? 'border-red-500' : 'border-[#FD5F20]'} rounded-lg focus:outline-none focus:ring-2 focus:ring-[#FD5F20] placeholder-gray-500`}
                                placeholder="Enter your phone number (e.g., +251911223344 or 0911223344)"
                                aria-label="Phone Number"
                            />
                            {errors.phoneNumber && <p className="text-red-500 text-sm mt-1">{errors.phoneNumber}</p>}
                        </div>
                    </div>
                    <div className="mb-2">
                        <button
                            type="submit"
                            className="w-full px-4 py-3 bg-[#FD5F20] opacity-90 text-white rounded-lg hover:bg-[#E6551C] focus:outline-none focus:ring-2 focus:ring-[#FF6A33]"
                        >
                            Sign Up
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default PlaylistPage;